export { default as Img200 } from './processed/200/inhertime.jpg';
export { default as Img400 } from './processed/400/inhertime.jpg';
export { default as Imgthumb } from './processed/thumb/inhertime.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/inhertime.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/inhertime.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      60,
      92,
      244
    ],
    "_population": 1,
    "_hsl": [
      0.6376811594202899,
      0.893203883495146,
      0.596078431372549
    ]
  },
  "LightVibrant": {
    "_rgb": [
      124,
      156,
      252
    ],
    "_population": 2,
    "_hsl": [
      0.625,
      0.9552238805970151,
      0.7372549019607844
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      90,
      50,
      30
    ],
    "_population": 631,
    "_hsl": [
      0.05555555555555555,
      0.5000000000000001,
      0.23529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      170,
      129,
      94
    ],
    "_population": 742,
    "_hsl": [
      0.07675438596491227,
      0.3089430894308942,
      0.5176470588235293
    ]
  },
  "LightMuted": {
    "_rgb": [
      206,
      161,
      148
    ],
    "_population": 153,
    "_hsl": [
      0.037356321839080414,
      0.3717948717948718,
      0.6941176470588235
    ]
  },
  "DarkMuted": {
    "_rgb": [
      53,
      55,
      92
    ],
    "_population": 77,
    "_hsl": [
      0.6581196581196581,
      0.2689655172413793,
      0.28431372549019607
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/inhertime.js